import { render, staticRenderFns } from "./DmsRolesFormActions.vue?vue&type=template&id=27e79f0b"
import script from "./DmsRolesFormActions.vue?vue&type=script&lang=js"
export * from "./DmsRolesFormActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports